import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import countryApi from 'api/countryApi'

export const thunkCountry = createAsyncThunk(
  'country/find',
  async (param, thunkApi) => {
    try {
      const res = await countryApi.getAll(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
const reportSlice = createSlice({
  name: 'country',
  initialState: {
    processes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunkCountry.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(thunkCountry.fulfilled, (state, action) => {
        state.loading = false
        state.processes = action.payload // Cập nhật state với dữ liệu trả về
      })
  },
})

const { reducer } = reportSlice
export default reducer
